export const ActionTypes = {
  LOADING: "SELECTED_OPTION2_LOADING",
  ERROR: "SELECTED_OPTION2_ERROR",
  SUCCESS: "SELECTED_OPTION2_SUCCESS",
};
